import { useMemo } from "react";

// Types
import { UploadFile } from "../../types";

// Icons
import { FiImage, FiMusic, FiVideo, FiFileText, FiFile } from "react-icons/fi";


interface FileMessageProps {
  file: UploadFile;
}

const FileMessage: React.FC<FileMessageProps> = ({ file }) => {

  const fileIcon = useMemo(() => {
    if (file.type?.includes('image')) return <FiImage size={22} />;
    if (file.type?.includes('audio')) return <FiMusic size={22} />;
    if (file.type?.includes('video')) return <FiVideo size={22} />;
    if (file.type?.includes('pdf')) return <FiFileText size={22} />;
    return <FiFile size={22} />;
  }, [file]);

  const fileSize = useMemo(() => {
    if (!file.size) return 'Unknown';
    return `${(file.size / 1024 / 1024).toFixed(2)} MB`;
  }, [file]);

  const containerClasses = "flex flex-row gap-2 p-2 flex-1 items-center justify-start";
  const messageClasses = "flex flex-col gap-2";
  const fileIconClasses = "flex flex-row gap-2 items-center";
  const fileNameClasses = "text-sm text-black";
  const fileSizeClasses = "text-xs text-gray-500";

  if (!file) return null;
  return (
    <div className={containerClasses}>
      <div className={messageClasses}>
        <div className={fileIconClasses}>
          {fileIcon}
        </div>
        <div className={fileNameClasses}>
          <p className={fileNameClasses}>
            {file.filename}
          </p>

          <p className={fileSizeClasses}>
            {fileSize}
          </p>
        </div>
      </div>
    </div>
  );
}

export default FileMessage;
